import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Profile } from "./../shared/models/profile";
import { Subject } from "rxjs";

import { AppSettingsService } from "./../../shared/services/app-settings.service";
import { UserService } from "./../../shared/services/user.service";
import { ViewStateService } from "./../../shared/services/view-state.service";
import { PractitionerMocksService } from "./../../shared/services/mocks/practitioner-mocks.service";
import { PractitionerService } from "../shared/services/practitioner.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
})
export class ProfileComponent implements OnInit, OnDestroy {
  profile: Profile = new Profile();
  personId?: string;
  allowEdit: boolean;
  birthday: string;
  private destroy$ = new Subject<void>();

  // private dateFormat = this.appSettings.IsCompatibilityMode ? 'MM/DD/YYYY' : 'YYYY-MM-DD';

  constructor(
    private route: ActivatedRoute,
    private practitionerMocksService: PractitionerMocksService,
    private appSettings: AppSettingsService,
    private userService: UserService,
    private viewState: ViewStateService,
    private practitionerService: PractitionerService
  ) {}

  ngOnInit() {
    this.viewState.startLoading();
    this.personId = this.userService.CurrentUser.personId;
    this.getProfileDetails();
  }

  private getProfileDetails() {
    if (this.personId) {
      this.practitionerService
        .getProfile(this.personId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((details) => {
          this.profile = details;
          if (details.birthday) {
            const dateString = new Date(details.birthday).toLocaleString(
              "en-US",
              { timeZone: "UTC" }
            );
            this.birthday = new Date(dateString).toString();
          }
          //this.retrieveUserCredentialsAndExams(this.personId);
        });
    } else {
      this.viewState.stopLoading();
    }
  }

  // private retrieveUserCredentialsAndExams(personId: string) {
  //   forkJoin([
  //     this.practitionerService.getEligibleExams(personId),
  //     this.practitionerService.getCredentials(personId),
  //   ])
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe((results) => {
  //       let hasEligibleExams = false,
  //         hasCredentials = false;
  //       if (results[0])
  //         {hasEligibleExams = results[0].find((e) => e.schedulingLink);}
  //       if (results[1]) {hasCredentials = results[1].find((e) => e !== null);}
  //       this.viewState.stopLoading();
  //     });
  // }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
